import QuoteIcon from '../QuoteIcon/QuoteIcon';
import type { SimpleQuoteProps } from './interfaces';
import styles from './SimpleQuote.module.scss';

const SimpleQuote = ({ quote, author, title }: SimpleQuoteProps) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.base}>
        <div className={styles.icon}>
          <QuoteIcon />
        </div>
        <div className={styles.quote}>{quote}</div>
        <div className={styles.author}>
          <strong className={styles.authorName}>{author}</strong>
          {title && <span className={styles.authorJob}>{title}</span>}
        </div>
      </div>
    </div>
  );
};

export default SimpleQuote;
